import { InputsForm1 } from "../types/InputsForm1";
import dayjs from "dayjs";
import { EMAIL_PATTERN } from "./normalizeEmail";

/**
 * Form1の必須項目バリデーション
 * @param form1 - Form1のデータ
 * @returns エラーメッセージの配列（エラーがない場合は空配列）
 */
export const validateForm1 = (form1: InputsForm1, lang: string): string[] => {
  const errors: string[] = [];

  // 個人情報取扱同意
  if (!form1.agree || form1.agree === "") {
    errors.push("- 個人情報取扱について同意してください");
  }

  // 申込者: 氏名（漢字）
  if (lang === 'ja' && (!form1.applicant.name.kanji.last || form1.applicant.name.kanji.last.trim() === "")) {
    errors.push("- 申込者の氏名（姓）を入力してください");
  }
  if (lang === 'ja' &&  (!form1.applicant.name.kanji.first || form1.applicant.name.kanji.first.trim() === "")) {
    errors.push("- 申込者の氏名（名）を入力してください");
  }

  // 申込者: 氏名（カナ）
  if (!form1.applicant.name.kana.last || form1.applicant.name.kana.last.trim() === "") {
    errors.push("- 申込者の氏名（セイ）を入力してください");
  } else if (lang === 'ja' &&  !/^[ァ-ンヴー]+$/i.test(form1.applicant.name.kana.last)) {
    errors.push("- 申込者の氏名（セイ）は全角カタカナで入力してください");
  }

  if (!form1.applicant.name.kana.first || form1.applicant.name.kana.first.trim() === "") {
    errors.push("- 申込者の氏名（メイ）を入力してください");
  } else if (lang === 'ja' &&  !/^[ァ-ンヴー]+$/i.test(form1.applicant.name.kana.first)) {
    errors.push("- 申込者の氏名（メイ）は全角カタカナで入力してください");
  }

  // 申込者: 生年月日
  if (!form1.applicant.birthday_year || !form1.applicant.birthday_month || !form1.applicant.birthday_day) {
    errors.push("- 申込者の生年月日を入力してください");
  } else {
    // 18歳以上チェック
    const birthday = dayjs(`${form1.applicant.birthday_year}-${form1.applicant.birthday_month}-${form1.applicant.birthday_day}`);
    const today = dayjs();
    const age = today.diff(birthday, "year");
    if (age < 18) {
      errors.push("- 予約日に18歳未満の方はお申し込みできません");
    }
  }

  // 申込者: 性別
  if (!form1.applicant.gender || form1.applicant.gender === "") {
    errors.push("- 申込者の性別を選択してください");
  }

  // 申込者: メールアドレス
  if (!form1.applicant.email || form1.applicant.email.trim() === "") {
    errors.push("- メールアドレスを入力してください");
  } else if (!EMAIL_PATTERN.test(form1.applicant.email)) {
    errors.push("- メールアドレスの形式が正しくありません");
  }

  if (!form1.applicant.email_confirm || form1.applicant.email_confirm.trim() === "") {
    errors.push("- メールアドレス（確認）を入力してください");
  } else if (form1.applicant.email !== form1.applicant.email_confirm) {
    errors.push("- メールアドレスが一致しません");
  }

  // 申込者: 住所
  if (!form1.applicant.address.zip_code || form1.applicant.address.zip_code.trim() === "") {
    errors.push("- 郵便番号を入力してください");
  } else if (!/^[0-9]+$/i.test(form1.applicant.address.zip_code)) {
    errors.push("- 郵便番号は半角数字で入力してください");
  }

  if (!form1.applicant.address.prefecture || form1.applicant.address.prefecture.trim() === "") {
    errors.push("- 都道府県を選択してください");
  }

  if (!form1.applicant.address.address_main || form1.applicant.address.address_main.trim() === "") {
    errors.push("- 市区町村 町名番地を入力してください");
  }

  // 申込者: 連絡先
  if (!form1.applicant.tel || form1.applicant.tel.trim() === "") {
    errors.push("- 携帯番号を入力してください");
  } else if (!/^(0{1}\d{9,10})$/i.test(form1.applicant.tel)) {
    errors.push("- 携帯番号の形式が正しくありません");
  }

  // 緊急連絡先（任意だが、入力されている場合は形式チェック）
  if (form1.applicant.emergency_tel && form1.applicant.emergency_tel.trim() !== "") {
    if (!/^(0{1}\d{9,10})$/i.test(form1.applicant.emergency_tel)) {
      errors.push("- 緊急連絡先の電話番号形式が正しくありません");
    }
  }

  // 代表者情報: 旅行参加の有無
  if (!form1.representative.is_applicant_join || form1.representative.is_applicant_join === "") {
    errors.push("- 申込者のご旅行参加の有無を選択してください");
  }

  // 代表者が別途いる場合（is_applicant_join = "no"）
  if (form1.representative.is_applicant_join === "no") {
    // 代表者: 氏名（漢字）
    if (!form1.representative.name.kanji.last || form1.representative.name.kanji.last.trim() === "") {
      errors.push("- 旅行の代表者様の氏名（姓）を入力してください");
    }
    if (!form1.representative.name.kanji.first || form1.representative.name.kanji.first.trim() === "") {
      errors.push("- 旅行の代表者様の氏名（名）を入力してください");
    }

    // 代表者: 氏名（カナ）
    if (!form1.representative.name.kana.last || form1.representative.name.kana.last.trim() === "") {
      errors.push("- 旅行の代表者様の氏名（セイ）を入力してください");
    } else if (lang === 'ja' && !/^[ァ-ンヴー]+$/i.test(form1.representative.name.kana.last)) {
      errors.push("- 旅行の代表者様の氏名（セイ）は全角カタカナで入力してください");
    }

    if (!form1.representative.name.kana.first || form1.representative.name.kana.first.trim() === "") {
      errors.push("- 旅行の代表者様の氏名（メイ）を入力してください");
    } else if (lang === 'ja' && !/^[ァ-ンヴー]+$/i.test(form1.representative.name.kana.first)) {
      errors.push("- 旅行の代表者様の氏名（メイ）は全角カタカナで入力してください");
    }

    // 代表者: 性別
    if (!form1.representative.gender || form1.representative.gender === "") {
      errors.push("- 旅行の代表者様の性別を選択してください");
    }

    // 代表者: 生年月日
    if (!form1.representative.birthday_year || !form1.representative.birthday_month || !form1.representative.birthday_day) {
      errors.push("- 旅行の代表者様の生年月日を入力してください");
    }

    // 代表者: 連絡先
    if (!form1.representative.tel || form1.representative.tel.trim() === "") {
      errors.push("- 旅行の代表者様の携帯番号を入力してください");
    } else if (!/^(0{1}\d{9,10})$/i.test(form1.representative.tel)) {
      errors.push("- 旅行の代表者様の携帯番号形式が正しくありません");
    }
  }

  // 同行者情報のバリデーション（フィールドが入力されている場合のみ）
  if (form1.followers && form1.followers.length > 0) {
    form1.followers.forEach((follower, index) => {
      const followerNum = index + 1;

      // 同行者氏名（カナ）
      if (follower.name.kana.last && follower.name.kana.last.trim() !== "") {
        if (lang === 'ja' && !/^[ァ-ンヴー]+$/i.test(follower.name.kana.last)) {
          errors.push(`- 同行者${followerNum}の氏名（セイ）は全角カタカナで入力してください`);
        }
      } else if (follower.name.kana.first && follower.name.kana.first.trim() !== "") {
        // 名が入力されているのに姓が空の場合
        errors.push(`- 同行者${followerNum}の氏名（セイ）を入力してください`);
      }

      if (follower.name.kana.first && follower.name.kana.first.trim() !== "") {
        if (lang === 'ja' && !/^[ァ-ンヴー]+$/i.test(follower.name.kana.first)) {
          errors.push(`- 同行者${followerNum}の氏名（メイ）は全角カタカナで入力してください`);
        }
      }
    });
  }

  return errors;
};
